// notify-client.js — Benachrichtigungen in App und Platzverwaltung (Server: routes/notifications.js, lib/notify.js).
// Rein: notifText, notifHref. Ablauf: createNotifier (Zähler abfragen, Abzeichen setzen), notificationsTpl (Liste).
import { url as areaUrl } from './hosts.js';

const KEY = { message: 'message', inquiry: 'inquiry', review: 'review', contrib: 'contrib' };

/** Text einer Benachrichtigung aus Art + Daten (nie ein Nachrichtentext). t = Übersetzer. */
export function notifText(n, t) {
  const d = (n && n.data) || {};
  const spot = d.spot_name || t('notify.spot_unknown');
  switch (n && n.kind) {
    case KEY.message: return t(d.from_team ? 'notify.message_team' : 'notify.message_op', { subject: d.subject || '' });
    case KEY.inquiry: return t('notify.inquiry', { spot });
    case KEY.review: return t('notify.review', { spot, rating: d.rating ?? '' });
    case KEY.contrib: {
      const what = ['spot', 'edit', 'claim'].includes(d.what) ? d.what : 'spot';
      return t(`notify.contrib_${what}_${d.approved ? 'ok' : 'no'}`, { spot });
    }
    default: return '';
  }
}

/** Ziel einer Benachrichtigung (Adresse im richtigen Bereich) oder null. */
export function notifHref(n, url = areaUrl) {
  const d = (n && n.data) || {};
  const num = (v) => (Number.isInteger(Number(v)) && Number(v) > 0 ? Number(v) : null);
  switch (n && n.kind) {
    case KEY.message: return num(d.conversation_id) ? url(d.from_team ? 'partner' : 'admin', '/nachrichten/' + num(d.conversation_id)) : null;
    case KEY.inquiry: return num(d.inquiry_id) ? url('partner', '/anfragen/' + num(d.inquiry_id)) : url('partner', '/');
    case KEY.review: return num(d.spot_id) ? url('app', '/spots/' + num(d.spot_id)) : null;
    case KEY.contrib:
      if (d.what === 'claim' && d.approved) return url('partner', '/spots');
      return num(d.spot_id) && d.approved !== false ? url('app', '/spots/' + num(d.spot_id)) : url('app', '/profil');
    default: return null;
  }
}

export const NOTIFY_ICONS = { message: 'mail', inquiry: 'inbox', review: 'star', contrib: 'task_alt' };

/**
 * Zähler regelmäßig abfragen (alle 60 s, nur sichtbar; sofort beim Zurückkehren) und weitergeben.
 * get = (url) => Promise<{ok,data}>. Rückgabe: { refresh, stop }.
 */
export function createNotifier({ get, onCount, intervalMs = 60000 }) {
  let timer = 0, stopped = false;
  const refresh = async () => {
    if (stopped) return;
    const r = await get('/api/notifications').catch(() => null);
    if (r && r.ok && r.data) onCount(Number(r.data.unread) || 0, r.data.items || []);
  };
  const tick = () => { clearTimeout(timer); if (stopped) return; if (document.visibilityState === 'visible') refresh(); timer = setTimeout(tick, intervalMs); };
  const onVis = () => { if (document.visibilityState === 'visible') refresh(); };
  document.addEventListener('visibilitychange', onVis);
  tick();
  return { refresh, stop() { stopped = true; clearTimeout(timer); document.removeEventListener('visibilitychange', onVis); } };
}
